import styled from 'styled-components';
import { media, textSizes, weights } from 'utils/style';

import NonFeasibleEstimationMessage from './NonFeasibleEstimationMessage';

export default styled(NonFeasibleEstimationMessage)`
  font-size: 1.6rem;
  margin-bottom: 3rem;
  display: flex;
  flex-direction: column;
  ${media.lessThan('large')`
    flex-direction: column-reverse;
    align-items: start;
    margin-bottom: 5px;
    margin-top: 50px;
    padding-top: 7px;
  `}
  ${media.lessThan('small')`
    padding-top: 0;
    margin: 0;
  `}
  & > div {
    ${media.lessThan('large')`
      display: flex;
      padding: 0 0 16px 16px;
      flex-direction: column-reverse;
    `}
    ${media.lessThan('small')`
      height: auto;
      flex-direction: row-reverse;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 0 24px 10px;
  `}
  }
  .non-feasible-estimation-title {
    ${media.lessThan('large')`
    display: none;
  `}
  }

  .tag {
    background-color: var(--accent100);
    color: var(--accent900);
    margin-right: 2rem;
    width: fit-content;
    svg {
      margin-left: 0.6rem;
      position: relative;
      top: 3px;
      path {
        fill: var(--accent500);
      }
    }
    ${media.lessThan('large')`
      margin: auto 0;
  `}
  }

  .price-range {
    color: var(--grey900);
    font-weight: 500;
    display: inline-block;
    font-size: ${textSizes('XXL')};
    color: var(--grey900);
    font-weight: ${weights('medium')};
    & > svg {
      visibility: hidden;
      ${media.lessThan('large')`
        visibility: visible;
        position: relative;
        margin-left: 0.6rem;
        cursor: pointer;
        margin-bottom: 5px;
      `}
    }
  }

  .extra-info {
    margin-top: 1rem;
    font-size: 1.2rem;
    font-style: italic;
    color: var(--grey800);
    ${media.lessThan('large')`
      border: 1px solid #E2E8EE;
      background-color: #F2F5F8;
      position: absolute;
      bottom: 99px;
      width: 100%;
      padding: 16px 24px;
    `}
    ${media.lessThan('small')`
      position: unset;
      margin: 0 0 16px;
    `}
  }
`;
/** ###
 * full window with
 * title styles
 * estimation icon styles
 */
